import { Box } from "@chakra-ui/react";
import React from "react";
import ExploreEdit from "src/components/explore-id";
import useCurrentUser from "src/components/useCurrentUser";
import { usePageContext } from "vike-react/usePageContext";
import { navigate } from "vike/client/router";

const ROOT = "/gallery";

const GalleryPage = () => {
    const { data: currentUser } = useCurrentUser(false);
    const { urlParsed } = usePageContext();
    React.useEffect(() => {
        if (typeof window === 'undefined') return;
        if (currentUser) {
            navigate(urlParsed.pathname.replace("/gallery", "/explore"));
        }
    }, [currentUser]);
    const navbarHeight = "88px";
    return (
        <Box
            h={`calc(100vh - ${navbarHeight})`}
            w="100%"
        >
            <ExploreEdit
                root={ROOT}
            />
        </Box>

    );
}
export default GalleryPage;
